import type { AccountGroupingData } from './utils';
import type { CustomEventProperties } from './tools/segment';
import { newUserSignup } from './new-user-signup';
import { formSubmit } from './form-submit';

export interface UserCreatedData {
  submitSuccess: boolean;
  plan: string;
  errorMessage?: string;
}

/**
 * Track when user attempt to verify email.
 */
export const userCreated = ({
  submitSuccess,
  plan,
  errorMessage,
}: UserCreatedData): Promise<void> => {
  const submitFormData = submitSuccess ? {} : { app_form_submit_failure_reason: errorMessage };

  if (submitSuccess) {
    // FE Tracking of new account signups.
    newUserSignup(plan);
  }
  return formSubmit({
    name: 'User creation',
    submitSuccess,
    groupData: {} as AccountGroupingData,
    data: submitFormData as CustomEventProperties,
  });
};

export const userCreatedError = (errorMessage: string): Promise<void> => {
  return formSubmit({
    name: 'User creation',
    submitSuccess: false,
    groupData: {} as AccountGroupingData,
    data: { app_form_submit_failure_reason: errorMessage },
  });
};
